import * as Yup from 'yup'
const { object, string } = Yup

Yup.addMethod(string, "checkIfEmailIsLoginEmail", function (errorMessage) {
    return this.test(`test-email`, errorMessage, function(value) {
        const { path, createError } = this;
        const enteredEmail = value?.trim();
        const userEmail = localStorage.getItem('email')
        return enteredEmail !== userEmail || createError({ path, message: errorMessage });
    })
})

const emailSchema = object().shape({
    email: string().required('*Email is required').email('*Please enter a correct email format').checkIfEmailIsLoginEmail('You can\'t send an invite to the same email as your login.'),
})

export default emailSchema
